export const formatPercentage = (value: number): string => {
  return `${value.toFixed(2)}%`
}
